import { render, staticRenderFns } from "./modal-offer-xmasrush-3.vue?vue&type=template&id=1c5c27fb&scoped=true"
import script from "./modal-offer-xmasrush-3.vue?vue&type=script&lang=js"
export * from "./modal-offer-xmasrush-3.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-xmasrush-3.vue?vue&type=style&index=0&id=1c5c27fb&prod&lang=scss"
import style1 from "./modal-offer-xmasrush-3.vue?vue&type=style&index=1&id=1c5c27fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c27fb",
  null
  
)

export default component.exports